import React, { Component } from 'react';
import '../css/style.css';
import '../components/Home.css';
import WithSearchLayout from './WithSearchLayout';
import SimpleLayout from './SimpleLayout';

import { translate } from "react-i18next";


class OtherEventsLayout extends Component {

    render(){
        const { t } = this.props;
        const { params } = this.props.match
         return (<SimpleLayout title={t("otherEvents")} >
         <WithSearchLayout preURL="subscription/creator" id={params.id} />
     </SimpleLayout>)
       }
}

export default translate("translations")(OtherEventsLayout);